import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppAside } from './app-aside.component';

@NgModule({
  declarations: [
    AppAside
  ],
  imports: [
    BrowserModule
  ],
  exports: [
    AppAside
  ]
})
export class AppAsideModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/app-aside/app-aside.module.ts